import React from 'react';
import styles from './Wallpaper.module.css';

/**
 * Renders the macOS Tahoe default wallpaper background.
 */
export function Wallpaper() {
  return (
    <div className={styles.wallpaper} aria-hidden="true">
      <img
        src="/assets/macOS_Tahoe_Default.jpg"
        alt=""
        className={styles.wallpaperImage}
      />
    </div>
  );
}
